import { useCallback } from 'react';
import { type ModalProps } from '~/modal/modalType.enum';
import { useModal } from '~/modal/useModal.hook';
import { PurchaseDataPackageType } from '~/purchaseDataPackage/modal/purchaseDataPackageModal.component';
import { DataLayerEditorModalComponent } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/modals/dataLayerEditorModal.component';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { useGetBoundaryGroup } from '~/store/boundaryGroups/boundaryGroups.selectors';
import { useActivePremiumDemographicsPackagesSelector } from '~/store/demographics/premiumDemographics/demographicsListPremium.selectors';
import { usePremiumDemographicsList } from '~/store/demographics/premiumDemographics/usePremiumDemographicsList';
import type { DataLayerData } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export const DataLayerEditorModalContainer = ({
  boundaryGroupId,
  ...restProps
}: ModalProps<{
  boundaryGroupId: BoundaryGroupId;
  initialData?: Partial<DataLayerData>;
  onSubmit: (dataLayerData: DataLayerData, alsoSaveTemplate?: boolean) => void;
}>) => {
  const { getBoundaryGroupById } = useGetBoundaryGroup();
  const { agsData, agsDataPurchased, isLoading } = usePremiumDemographicsList();
  const selectedPackages = useActivePremiumDemographicsPackagesSelector().purchased;
  const { openModal: openPurchaseDataPackageModal } = useModal('PurchaseDataPackage');

  const boundaryGroup = getBoundaryGroupById(boundaryGroupId);
  const boundaryGroupName = boundaryGroup?.name ?? '';

  const onUpgrade = useCallback(() => {
    openPurchaseDataPackageModal({ type: PurchaseDataPackageType.DataLayer });
  }, [openPurchaseDataPackageModal]);

  return (
    <DataLayerEditorModalComponent
      boundaryGroupName={boundaryGroupName}
      demographicsPerRegion={agsData}
      purchasedDemographics={agsDataPurchased}
      isLoading={isLoading}
      selectedPackages={selectedPackages}
      onUpgrade={onUpgrade}
      {...restProps}
    />
  );
};
